import React from "react";
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from "react-router-dom";
import { getInit } from '../../redux/actions/init.action';
import { callTrial } from '../../redux/actions/rLink.action';
import { setActive } from '../../redux/middleware/sockets.funcs';
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
// react plugin for creating notifications over the dashboard
import Footer from "components/Footer/Footer.jsx";
import { withTranslation } from "react-i18next";
import NotificationAlert from "react-notification-alert";
import {
  Button
} from "reactstrap";
import Profile from "views/Profile.jsx";
import Setup from "views/Setup.jsx";
import ScrollToTop from '../../components/ScrollToTop';

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import routes from "routes.js";
var ps = [];

class Admin extends React.Component {
  constructor() {
    super();
    this.mainPanelRef = React.createRef();
    this.notificationAlertRef = React.createRef();
    this.state = {
      opacity: 0,
      sidebarOpened: false
    }
    document.body.classList.toggle("sidebar-mini");
  }

  handleFocus = () => {
    //this.props.setActive(true);
  };

  handleClick = () => {
    if (this.props.vip.plan < 1)
      return;
    this.props.setActive(true);
  };
  
  handleBlur = () => {
    //this.props.setActive(false);
  };
  
  handleVisibilityChange = () => {
    if (document.visibilityState === 'visible' && this.props.vip.plan >= 1) {
      this.props.setActive(true);
    } else {
      this.props.setActive(false);
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleFocus);
    window.removeEventListener('blur', this.handleBlur);
    window.removeEventListener("scroll", this.handleClick);
    window.removeEventListener("click", this.handleClick);
    this.props.setActive(false);
  };


  componentDidMount = async () => {

    await this.props.getInit();
    this.props.setActive(this.props.vip.plan >= 1 ? true : false);

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('focus', this.handleFocus);
    window.addEventListener('blur', this.handleBlur);
    window.addEventListener("scroll", this.handleClick);
    window.addEventListener("click", this.handleClick);
    
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (this.mainPanelRef.current) {
      this.mainPanelRef.current.scrollTop = 0;
    }
    let innerMainPanelRef = this.mainPanelRef;
    if (navigator.platform.indexOf("Win") > -1 && this.mainPanelRef.current) {
      document.documentElement.classList.add("perfect-scrollbar-on");
      document.documentElement.classList.remove("perfect-scrollbar-off");
      if (this.mainPanelRef.current)
      {
        ps.push(new PerfectScrollbar(this.mainPanelRef.current));
        this.mainPanelRef.current.addEventListener("ps-scroll-y", this.showNavbarButton);
      }
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        ps.push(new PerfectScrollbar(tables[i]));
      }
    }
    window.addEventListener("scroll", this.showNavbarButton);
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        for (var perfect of ps)
          perfect.destroy();
        document.documentElement.classList.add("perfect-scrollbar-off");
        document.documentElement.classList.remove("perfect-scrollbar-on");
        innerMainPanelRef.current &&
          innerMainPanelRef.current.removeEventListener(
            "ps-scroll-y",
            this.showNavbarButton
          );
      }
      window.removeEventListener("scroll", this.showNavbarButton);
    };
  };
  setOpacity = (value) => {
    this.setState({
      opacity: value
    });
  }
  setSidebarOpened = (value) => {
    this.setState({
      sidebarOpened: value
    });
  }
  showNavbarButton = () => {
    if (
      document.documentElement.scrollTop > 50 ||
      document.scrollingElement.scrollTop > 50 ||
      (this.mainPanelRef.current && this.mainPanelRef.current.scrollTop > 50)
    ) {
      this.setOpacity(1);
    } else if (
      document.documentElement.scrollTop <= 50 ||
      document.scrollingElement.scrollTop <= 50 ||
      (this.mainPanelRef.current && this.mainPanelRef.current.scrollTop <= 50)
    ) {
      this.setOpacity(0);
    }
  };
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      return (
        <Route
          path={prop.path}
          component={prop.component}
          key={key}
        />
      );
    });
  };
  redirectToRoute = () => {
    const index = routes.findIndex((r) => r.path === window.location.pathname);
    if (index > -1) return window.location.pathname;
    else return "/setup";
  }
  getActiveRoute = (routes) => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.pathname.indexOf(
          routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return activeRoute;
  };
  handleMiniClick = () => {
    document.body.classList.toggle("sidebar-mini");
  };
  toggleSidebar = () => {
    this.setSidebarOpened(!this.sidebarOpened);
    document.documentElement.classList.toggle("nav-open");
  };
  closeSidebar = () => {
    this.setSidebarOpened(false);
    document.documentElement.classList.remove("nav-open");
  };
  render() {
    return (
      <div className="wrapper">
        {this.props.redirect !== "false" && <Redirect to={this.props.redirect} />}
        <div className="rna-container">
          <NotificationAlert ref={this.notificationAlertRef} />
        </div>
        <div className="navbar-minimize-fixed" style={{ opacity: this.state.opacity }}>
          <button
            className="minimize-sidebar btn btn-link btn-just-icon"
            onClick={this.handleMiniClick}
          >
            <i className="tim-icons icon-align-center visible-on-sidebar-regular text-muted" />
            <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini text-muted" />
          </button>
        </div>
        <Sidebar
          {...this.props}
          routes={routes}
          activeColor={"blue"}
          closeSidebar={this.closeSidebar}
        />
        <div className="main-panel" ref={this.mainPanelRef} data={"blue"}>
          <ScrollToTop>
            <AdminNavbar
              {...this.props}
              handleMiniClick={this.handleMiniClick}
              brandText={this.props.t(this.getActiveRoute(routes))}
              sidebarOpened={this.sidebarOpened}
              toggleSidebar={this.toggleSidebar}
            />
            {(this.props.vip.plan < 2 && this.props.vip.canTrial) && <div className="TrialBar">
              <div className="TrialText">{this.props.t('common:trialText')}</div>
              <div className="TrialBtn">
                <Button color="info" onClick={() => this.props.callTrial()}>
                  {this.props.t('common:trialBtn')}
                </Button>
              </div>
            </div>}
            <Switch>
                {this.getRoutes(routes)}
                <Route path="/profile" component={Profile} key="profile"/>
                <Route path="/" component={Setup} key="setup"/>
                {/*<Redirect from="*" to="/setup" />*/}
            </Switch>
            <Redirect to={this.redirectToRoute()} />
            <Footer fluid />
          </ScrollToTop>
        </div>
      </div>
    );
  };
};

const mapDispatchToProps = {
  getInit,
  callTrial,
  setActive
};

const mapStateToProps = (state) => {
  const { redirect } = state.rLink;
  const { vip } = state.infos;
  return { redirect, vip };
};

export default withTranslation(["pages", "common"])(connect(mapStateToProps, mapDispatchToProps)(Admin));